import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage by default
import Reducer from './reducers/Reducer';
 

// 1. Combine your reducers
const rootReducer = combineReducers({
  app: Reducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['app'], // only persist the 'app' reducer
};

// 3. Wrap rootReducer with persistReducer
const persistedReducer = persistReducer<ReturnType<typeof rootReducer>, any>(persistConfig, rootReducer as any);

// 4. Create the store with persisted reducer
export const store = createStore(persistedReducer);

// 5. Create the persistor
export const persistor = persistStore(store);

// 6. Export RootState type
export type RootState = ReturnType<typeof rootReducer>;
